import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "../constants";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { useTranslation } from "../LanguageContext";

function ForgetPassword() {
    const { t } = useTranslation();
    const [stage, setStage] = useState(0)
    const [errors, setErrors] = useState([]);
    const [find2, setFind2] = useState("");
    const [email, SetEmail] = useState(null)
    const [selectedValue, setSelectedValue] = useState('email');
    const [token, setToken] = useState("");
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    };

    const Stage0 = () => {
        const [find, setFind] = useState("");

        const handleSubmit = async (e) => {
            setErrors([]);
            e.preventDefault();
            try {
                setLoading(true);
                const res = await api.post("/api/reset-password/", { stage: stage, find: find });
                setFind2(find)
                if (res.data.email !== "") {
                    SetEmail(res.data.email)
                }
                setLoading(false);
                setStage(1)
            } catch (error) {
                setLoading(false);
                setErrors([error.response.data.user]);
            }
        };

        return <>
            <h1 className="text-2xl font-bold text-slate-800 mb-2">{t('forget.title0')}</h1>
            <p className="text-sm text-slate-500 mb-6">{t('forget.desc0')}</p>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="label">{t('forget.label0')}</label>
                    <input className="input" type="text" value={find} onChange={(e) => setFind(e.target.value)} maxLength={254} required />
                </div>
                <button className="btn-primary w-full flex items-center justify-center" type="submit" disabled={loading}>
                    {loading ? <div className="spinner-sm"></div> : "Submit"}
                </button>
            </form>
        </>
    }

    const Stage1 = () => {
        const handleChange = (event) => {
            setSelectedValue(event.target.value);
        };

        const handleSubmit = async (e) => {
            e.preventDefault();
            setErrors([]);
            try {
                setLoading(true);
                await api.post("/api/reset-password/", { stage: stage, find: find2, method: selectedValue });
                setLoading(false);
                setStage(2)
            } catch (error) {
                setLoading(false);
            }
        };

        return <>
            <h1 className="text-2xl font-bold text-slate-800 mb-2">{t('forget.title1')}</h1>
            <p className="text-sm text-slate-500 mb-6">{t('forget.desc1')}</p>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="p-4 bg-slate-50 rounded-xl">
                    <FormControl>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            value={selectedValue}
                            name="radio-buttons-group"
                            onChange={handleChange}
                        >
                            {email !== null && <FormControlLabel value="email" control={<Radio />} label={t('forget.sendEmail') + email} />}
                        </RadioGroup>
                    </FormControl>
                </div>
                <button className="btn-primary w-full flex items-center justify-center" type="submit" disabled={loading}>
                    {loading ? <div className="spinner-sm"></div> : "Submit"}
                </button>
            </form>
        </>
    }

    const Stage2 = () => {
        const [code, setCode] = useState("");
        const handleBack = () => {
            setStage(1)
        };

        const handleSubmit = async (e) => {
            setErrors([]);
            e.preventDefault();
            try {
                setLoading(true);
                const res = await api.post("/api/reset-password/", { stage: stage, find: find2, method: selectedValue, code: code });
                setToken(res.data.token)
                setLoading(false);
                setStage(3)
            } catch (error) {
                setLoading(false);
                setErrors([error.response.data]);
            }
        };

        return <>
            <h1 className="text-2xl font-bold text-slate-800 mb-2">{t('forget.title2')}</h1>
            <p className="text-sm text-slate-500 mb-6">{t('forget.desc2')}</p>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="label">{t('forget.label2')}</label>
                    <input className="input" type="text" value={code} onChange={(e) => setCode(e.target.value)} placeholder={t('forget.placeholder2')} maxLength={254} required />
                </div>
                <p className="text-xs text-slate-400">{t('forget.spamNote')}</p>

                {code === "" ? (
                    <button className="btn-secondary w-full" onClick={handleBack} type="button">{t('forget.back')}</button>
                ) : (
                    <button className="btn-primary w-full flex items-center justify-center" type="submit" disabled={loading}>
                        {loading ? <div className="spinner-sm"></div> : t('forget.submit')}
                    </button>
                )}
            </form>
        </>
    }

    const Stage3 = () => {
        const [New, setNew] = useState("");
        const [Confirm, setConfirm] = useState("");

        const handleSubmit = async (e) => {
            setErrors([]);
            e.preventDefault();
            if (New !== Confirm) {
                setErrors(["Passwords do not match"]);
                return;
            }
            try {
                setLoading(true);
                await api.post("/api/reset-password/", { stage: stage, token: token, new_password: New, find: find2 });
                localStorage.clear()
                const res = await api.post("/api/token", { "username": find2, "password": New })
                setLoading(false);
                localStorage.setItem(ACCESS_TOKEN, res.data.access);
                localStorage.setItem(REFRESH_TOKEN, res.data.refresh);
                navigate("/profile")
            } catch (error) {
                setLoading(false);
                setErrors([error.response.data]);
            }
        }

        return <>
            <h1 className="text-2xl font-bold text-slate-800 mb-2">{t('forget.title3')}</h1>
            <p className="text-sm text-slate-500 mb-6">{t('forget.desc3')}</p>
            <form onSubmit={handleSubmit} className="space-y-4">
                <input className="input" type="password" value={New} onChange={(e) => setNew(e.target.value)} placeholder={t('forget.newPlaceholder')} pattern="\S+" title={t('forget.noSpaces')} maxLength={128} minLength={8} required />
                <input className="input" type="password" value={Confirm} onChange={(e) => setConfirm(e.target.value)} placeholder={t('forget.confirmPlaceholder')} pattern="\S+" title={t('forget.noSpaces')} maxLength={128} minLength={8} required />
                <button className="btn-primary w-full flex items-center justify-center" type="submit" disabled={loading}>
                    {loading ? <div className="spinner-sm"></div> : t('forget.submit')}
                </button>
            </form>
        </>
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-primary-50 flex items-center justify-center px-4 py-12">
            <div className="w-full max-w-md">
                <div className="card">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-6">
                        <a href="/" className="text-slate-400 hover:text-primary-600 transition">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                            </svg>
                        </a>
                        <button type="button" className="text-slate-400 hover:text-slate-600 transition" onClick={goBack}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    {/* Stage content */}
                    <div className="text-center">
                        {stage === 0 && <Stage0 />}
                        {stage === 1 && <Stage1 />}
                        {stage === 2 && <Stage2 />}
                        {stage === 3 && <Stage3 />}

                        {errors.length > 0 && (
                            <ul className="list-none p-0 mt-4 space-y-1">
                                {errors.map((error, index) => (
                                    <li key={index} className="text-sm text-red-600">{` ${error}`}</li>
                                ))}
                            </ul>
                        )}
                    </div>

                    {/* Progress dots */}
                    <div className="flex justify-center gap-2 mt-6">
                        {[0, 1, 2, 3].map(i => (
                            <div key={i} className={`h-1.5 rounded-full transition-all duration-300 ${stage === i ? "w-6 bg-primary-600" : stage > i ? "w-1.5 bg-primary-300" : "w-1.5 bg-slate-200"}`} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ForgetPassword;